<template>
    <div>
        <el-form :inline="ifInLine" :model="dataForm" :size="size" style="text-align:left">
            <el-form-item label="省份" prop="partnersId">
                <el-select
                    v-model="dataForm.partnersId"
                    placeholder="请选择"
                    @change='handleSelectPro'>
                    <el-option
                        v-for="item in partnersList"
                        :key="item.partnersId"
                        :label="item.partnersName"
                        :value="item.partnersId"
                        >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="考试名称" prop="examId" v-if='baseObject.examSearch'>
                <el-select
                    v-model="dataForm.examId"
                    placeholder="请选择"
                    @change='handleSelectExam'
                    @visible-change='loadExam'
                    :loading='loadingExam'
                    loading-text="请先选择上一层"
                    no-data-text="请先选择上一层">
                    <el-option
                        v-for="item in examList"
                        :key="item.examId"
                        :label="item.examName"
                        :value="item.examId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="考区" prop="areaId" v-if='baseObject.areaSearch'>
                <el-select
                    v-model="dataForm.areaId"
                    placeholder="请选择"
                    :loading="loadingArea"
                    @change='handleSelectArea'
                    loading-text="请先选择上一层"
                    no-data-text="请先选择上一层">
                    <el-option
                        v-for="item in areaList"
                        :key="item.areaId"
                        :label="item.areaName"
                        :value="item.areaId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="机构" prop="agentId" v-if='baseObject.agentSearch'>
                <el-select
                    v-model="dataForm.agentId"
                    placeholder="请选择"
                    :loading='loadingAgent'
                    @change='handleSelectAgent'
                    loading-text="请先选择上一层"
                    no-data-text="请先选择上一层">
                    <el-option
                        v-for="item in agentList"
                        :key="item.agentId"
                        :label="item.agentName"
                        :value="item.agentId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="考生姓名" prop="studentName" v-if='baseObject.stuSearch'>
                <el-input v-model="dataForm.studentName" placeholder="请输入考生姓名"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="idNo" v-if='baseObject.idNoSearch'>
                <el-input v-model="dataForm.idNo" placeholder="请输入身份证号"></el-input>
            </el-form-item>
        </el-form>
        <el-form :inline="true" style='text-align:left'>
            <el-form-item style='margin-bottom:5px'>
                <perm-button
                    icon="fa fa-search"
                    label="搜索"
                    :perms="baseObject.searchPerms"
                    type="primary"
                    @click="findPage(null)"/>
            </el-form-item>
            <el-form-item style='margin-bottom:5px' v-if='baseObject.add'>
                <perm-button
                    icon="fa fa-plus"
                    :label="baseObject.addName?baseObject.addName:'添加'"
                    :perms="baseObject.addPerms"
                    type="success"
                    @click="handleAdd"/>
            </el-form-item>
            <el-form-item style='margin-bottom:5px' v-if='baseObject.add1'>
                <perm-button
                    icon="fa fa-plus"
                    label="手动编排考场"
                    :perms="baseObject.addPerms"
                    type="success"
                    @click="handleHandAdd"/>
            </el-form-item>
            <el-form-item style='margin-bottom:5px' v-if='baseObject.delete'>
                <perm-button
                    icon="fa el-icon-delete"
                    :label="baseObject.deleteName?baseObject.deleteName:'批量删除'"
                    :perms="baseObject.deletePerms"
                    type="danger"
                    @click="handleBatchDelete"/>
            </el-form-item>
            <el-form-item style='margin-bottom:5px' v-if='baseObject.printTicket'>
                <perm-button
                    icon="fa el-icon-printer"
                    label="批量打印准考证"
                    :perms="baseObject.printTicketPerms"
                    type="primary"
                    @click="handlePrintTicket"/>
            </el-form-item>
            <el-form-item style='margin-bottom:5px' v-if='baseObject.printRoom'>
                <perm-button
                    icon="fa el-icon-printer"
                    label="打印桌贴"
                    :perms="baseObject.printRoomPerms"
                    type="primary"
                    @click="handlePrintRoom"/>
            </el-form-item>
            <el-form-item style='margin-bottom:5px;' v-if='baseObject.publish'>
                <perm-button
                    icon="fa el-icon-position"
                    label="发布"
                    :perms="baseObject.publishPerms"
                    type="primary"
                    @click="handlePublish"/>
            </el-form-item>
            <el-form-item style='margin-bottom:5px;' v-if='baseObject.import'>
                <perm-button
                    icon="fa el-icon-upload"
                    label="导入考场"
                    :perms="baseObject.importPerms"
                    type="warning"
                    @click="handleImport"/>
            </el-form-item>
            <el-form-item style='margin-bottom:5px' v-if='baseObject.deleteBatch'>
                <perm-button
                    icon="fa el-icon-delete"
                    :label="baseObject.deleteBtachName?baseObject.deleteBtachName:'批量删除考场'"
                    :perms="baseObject.deletePerms"
                    type="danger"
                    @click="handleBatchDelete2"/>
            </el-form-item>
            <el-form-item style='margin-bottom:5px' v-if='baseObject.scoreExport'>
                <perm-button
                    icon="fa el-icon-sort"
                    label="成绩导出"
                    :perms="baseObject.scoreExportPerms"
                    type="success"
                    @click="handlescoreExport"/>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import PermButton from '../PermButton/Index'

export default {
    name: 'CascadeSearch',
    components: { PermButton },
    props: {
        ifInLine: Boolean,
        baseObject: Object
    },
    data() {
        return {
            size: 'small',
            partnersList: [],
            examList: [], // 考试
            areaList: [], // 考区
            agentList: [], // 机构
            dataForm: {
                partnersId: '',
                provinceId: '',
                examId: '',
                areaId: '',
                agentId: '',
                studentName: '',
                idNo: ''
            },
            pageRequest: {
                current: 1,
                size: 10
            },
            loadingExam: true,
            loadingArea: true,
            loadingAgent: true,
            acquiesce: {}
        }
    },
    methods: {
        loadExam(e) {
            if (e) {
                this.handelLoadExam()
            }
        },
        loadProvinceList() {
            this.partnersList = this.$store.state.partnersList.partnersList
            this.acquiesce = this.$store.state.partnersList.partnersAcquiesce
        },
        // 处理级联
        handleSelectPro(e) {
            this.examList = [] // 考试
            this.areaList = []// 考区
            this.agentList = [] // 机构
            this.dataForm.partnersId = ''
            this.dataForm.provinceId = ''
            this.dataForm.examId = ''
            this.dataForm.areaId = ''
            this.dataForm.agentId = ''
            this.dataForm.areaName = ''
            this.dataForm.examName = ''
            this.dataForm.agentName = ''
            let obj = {}
            obj = this.partnersList.find((item) => {
                return item.partnersId === e
            })
            this.dataForm.partnersId = obj.partnersId
            this.dataForm.provinceId = obj.provinceId
            this.handelLoadExam()
        },
        handleSelectExam(e) {
            this.areaList = []// 考区
            this.agentList = [] // 机构
            this.dataForm.areaId = ''
            this.dataForm.agentId = ''
            this.dataForm.areaName = ''
            this.dataForm.agentName = ''
            let obj = {}
            obj = this.examList.find((item) => {
                return item.examId === e
            })
            this.dataForm.examName = obj.examName
            if (!this.baseObject.areaSearch && this.baseObject.agentSearch) {
                this.handelLoadAgent()
                return
            }
            this.handelLoadArea()
        },
        handleSelectArea(e) {
            let obj = {}
            obj = this.areaList.find((item) => {
                return item.areaId === e
            })
            this.dataForm.areaName = obj.areaName
            this.handelLoadAgent()
        },
        handleSelectAgent(e) {
            let obj = {}
            obj = this.agentList.find((item) => {
                return item.agentId === e
            })
            this.dataForm.agentName = obj.agentName
        },
        handelLoadExam() {
            const data = {
                partnersId: this.dataForm.partnersId
            }
            this.$api.exam.getExamByProvince(data).then(res => {
                this.loadingExam = false
                this.examList = res.data
            })
        },
        handelLoadArea() {
            const data = {
                partnersId: this.dataForm.partnersId,
                examId: this.dataForm.examId
            }
            this.$api.exam.getAreaAgentByExamId(data).then(res => {
                this.loadingArea = false
                this.areaList = res.data
            })
        },
        handelLoadAgent() {
            this.agentList = [] // 机构
            this.dataForm.agentId = ''
            this.dataForm.agentName = ''
            const data = {
                partnersId: this.dataForm.partnersId,
                examId: this.dataForm.examId,
                areaId: this.dataForm.areaId
            }
            const user = JSON.parse(sessionStorage.getItem('user'))
            if (!this.baseObject.areaSearch && this.baseObject.agentSearch) {
                this.$api.exam.getAgentByExamId(data).then(res => {
                    let obj = res.data
                    if (user && user.agentId && res.data) { // 机构权限
                        obj = res.data.filter(item => item.agentId === user.agentId)
                        this.dataForm.agentId = user.agentId
                    }
                    this.agentList = obj
                    this.loadingAgent = false
                })
            } else {
                let obj = {}
                obj = this.areaList.find((item) => {
                    return item.areaId === this.dataForm.areaId
                })
                this.agentList = obj.children
                // 机构权限
                if (user && user.agentId) {
                    this.agentList = obj.children.filter(item => item.agentId === user.agentId)
                    this.dataForm.agentId = user.agentId
                }
                this.loadingAgent = false
            }
        },
        findPage() {
            if (!this.dataForm.partnersId) {
                this.$message.error({ message: '请先选择省份' })
                return
            }
            this.$emit('findPage', { pageRequest: this.pageRequest, filters: this.dataForm })
        },
        handleAdd() {
            this.$emit('handleAdd', {})
        },
        handleBatchDelete() {
            this.$emit('handleBatchDelete')
        },
        handlescoreExport() {
            this.$emit('handlescoreExport', { pageRequest: this.pageRequest, filters: this.dataForm })
        },
        handleBatchDelete2() {
            this.$emit('handleBatchDelete2', { pageRequest: this.pageRequest, filters: this.dataForm })
        },
        handlePrintTicket() {
            this.$emit('handlePrintTicket', { pageRequest: this.pageRequest, filters: this.dataForm })
        },
        handlePrintRoom() {
            this.$emit('handlePrintRoom', { pageRequest: this.pageRequest, filters: this.dataForm })
        },
        handlePublish() {
            this.$emit('handlePublish', { pageRequest: this.pageRequest, filters: this.dataForm })
        },
        handleImport() {
            this.$emit('handleImport', { pageRequest: this.pageRequest, filters: this.dataForm })
        },
        handleHandAdd() {
            this.$emit('handleHandAdd', { pageRequest: this.pageRequest, filters: this.dataForm })
        }
    },
    mounted() {
        this.loadProvinceList()
    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Component/CascadeSearch/Index.vue